import 'jquery';
import { Navigation } from '../../../../../Client/Scripts/Shared/navigation';
import { Amplitude } from '../../../../../Client/Scripts/Shared/amplitude';
import { PopoverOption } from 'bootstrap';

const initDealAddModal = () => {
	const $modal = $('#deal-add-modal');

	$('.btn-add-deal').click(function (e) {
		e.preventDefault();

		const href = $(this).attr('href');

		$.get(href, function (data) {
			$modal.find('.modal-body').empty().html(data);
			$modal.modal({ focus: false });
		});
	});

	const initDealAddForm = () => {
		const $form = $modal.find('#deal-add-form');
		let newCompanyMode: boolean = Boolean(JSON.parse(($form.find('#new-company-mode').val() as string).toLowerCase()));

		$form.find('.btn-new-company').click(() => {
			$form.find('.deal-add-form__select-company').toggleClass('d-none');
			$form.find('.deal-add-form__new-company').toggleClass('d-none');
			newCompanyMode = true;
		});

		$form.find('.btn-back-to-list').click(() => {
			$form.find('.deal-add-form__new-company').toggleClass('d-none');
			$form.find('.deal-add-form__select-company').toggleClass('d-none');
			newCompanyMode = false;
		});

		$form.find('.btn-upload-logo').click(function () {
			$('#company-logo').click();
			return false;
		});

		$form.on('submit', function (e) {
			e.preventDefault();
			const $this = $(this);

			const formData = new FormData();

			formData.append('NewCompanyMode', String(newCompanyMode));

			if (newCompanyMode) {
				formData.append('Name', $this.find('#company-name').val() as string);
				formData.append('Description', $this.find('#company-description').val() as string);
				formData.append('Link', $this.find('#company-link').val() as string);
				const fileData = $this.find('#company-logo').prop('files')[0];
				formData.append('CompanyLogo', fileData);
			}
			else {
				formData.append('SelectedCompany', $this.find('#company-select').val() as string || "");
			}

			initFormFiledsFormData($form, formData);

			$.ajax({
				url: $this.attr('action'),
				type: 'POST',
				dataType: 'text',
				cache: false,
				contentType: false,
				processData: false,
				data: formData,
				success: function (response) {
					$modal.modal('hide');

					const dealUrl = JSON.parse(response).url;
					Navigation.visit(dealUrl);
				},
				error: function (response) {
					$modal.find('.modal-body').empty().html(response.responseText);
					initDealAddForm();
				}
			});
		});
	};

	$modal.on('show.bs.modal', function (e) {
		initDealAddForm();
	});

	$modal.on('hidden.bs.modal', function (e) {
		$modal.find('.modal-body').empty();
	});
}

const initDealEditModal = (ClassicEditor: any) => {
	const $modal = $('#deal-edit-modal');
	let editor: any;

	function initDealCommentEditor() {
		const textareaEl = document.querySelector('#deal-comment-textarea');

		ClassicEditor.default.create(textareaEl, {
			toolbar: ['heading', '|', 'bold', 'italic', 'bulletedList', 'numberedList', 'insertTable', 'undo', 'redo'],
			heading: {
				options: [
					{ model: 'paragraph', title: 'Normal', class: 'ck-heading_paragraph' },
					{ model: 'heading5', view: 'h5', title: 'Title', class: 'ck-heading_heading5' },
					{ model: 'heading6', view: 'h6', title: 'Subtitle', class: 'ck-heading_heading6' }
				]
			},
			table: {
				toolbar: ['tableColumn', 'tableRow', 'mergeTableCells']
			}
		}).then((instance: any) => {
			editor = instance;
		});
	}

	function initDealCardBackgroundImageUpload() {
		const $inputFiles = $('#upload-background-image-file');

		$('#upload-background-image-btn').click(function () {
			$inputFiles.click();
		});
	}

	$('.btn-edit-deal-summary').click(function (e) {
		e.preventDefault();

		const href = $(this).attr('href');

		$.get(href, function (data) {
			$modal.find('.modal-body').empty().html(data);
			$modal.modal({ focus: false });
		});
	});

	var initDealEditForm = function () {
		initDealCommentEditor();
		initDealCardBackgroundImageUpload();

		var $form = $modal.find('#deal-edit-form');

		$form.on('submit', function (e) {
			e.preventDefault();

			if ($form.validate().form()) {
				const formData = new FormData();

				const fileData = $form.find('#upload-background-image-file').prop('files')[0];
				formData.append('Image', fileData);
				if (editor) {
					formData.append('Comment', editor.getData() as string);
				}

				initFormFiledsFormData($form, formData);

				$.ajax({
					url: $form.attr('action'),
					type: 'POST',
					dataType: 'text',
					cache: false,
					contentType: false,
					processData: false,
					data: formData,
					success: function (response) {
						$modal.modal('hide');

						const projectName = $('#project-name').val();
						Amplitude.logEvent('Deal - Edit Opportunity', {
							'Project': projectName
						});

						Navigation.reload();
					},
					error: function (response) {
						$modal.find('.modal-body').empty().html(response.responseText);
						if (editor != null) {
							editor.destroy();
							editor = null;
						}
						initDealEditForm();
					}
				});
			}
		});
	};

	$modal.on('show.bs.modal', function (e) {
		initDealEditForm();
	});

	$modal.on('hidden.bs.modal', function (e) {
		$modal.find('.modal-body').empty();
		if (editor != null) {
			editor.destroy();
			editor = null;
		}
	});
}

const initFormFiledsFormData = ($form: JQuery<HTMLElement>, formData: FormData) => {
	formData.append('InvestmentType', $form.find('#deal-investment-type-input').val() as string);
	formData.append('ValuationType', $form.find('#deal-valuation-type-input').val() as string);

	formData.append('Currency', $form.find('#deal-currency-select').val() as string);
	formData.append('Deadline', $form.find('#deal-dealline-input').val() as string);

	formData.append('Valuation', $form.find('#deal-valuation-input').val() as string);
	formData.append('MinimumCheck', $form.find('#deal-minimum-check-input').val() as string);

	formData.append('InvestmentTarget', $form.find('#deal-investment-target-input').val() as string);
	formData.append('CommittedAmount', $form.find('#deal-commitment-amount-input').val() as string);

	formData.append('ContactPerson', $form.find('#deal-contact-person-select').val() as string);
	formData.append('InvestedAmount', $form.find('#deal-invested-amount-input').val() as string);
}

const initDealShareModal = () => {
	const $modal = $('#deal-share-modal');

	$('.btn-share-deal').click(function (e) {
		e.preventDefault();

		const href = $(this).attr('href');

		$.get(href, function (data) {
			$modal.find('.modal-body').empty().html(data);
			$modal.modal({ focus: false });
		});
	});

	var initDealShareForm = function () {
		var $form = $modal.find('#deal-share-form');

		$form.find('#public-deal-checkbox').change((e) => {
			var checked = (e.target as any).checked;

			if (checked) {
				$form.find('.share-deal-checkbox').attr('disabled', 'disabled');
			}
			else {
				$form.find('.share-deal-checkbox').removeAttr('disabled');
			}
		});

		$form.on('submit', function (e) {
			e.preventDefault();

			if ($form.validate().form()) {
				$.ajax({
					data: $form.serialize(),
					type: $form.attr('method'),
					url: $form.attr('action'),
					contentType: 'application/x-www-form-urlencoded',
					success: function (response) {
						$modal.modal('hide');

						const projectName = $('#project-name').val();
						Amplitude.logEvent('Deal - Share', {
							'Project': projectName
						});

						Navigation.reload();
					},
					error: function (response) {
						$modal.find('.modal-body').empty().html(response.responseText);
						initDealShareForm();
					}
				});
			}
		});
	};

	$modal.on('show.bs.modal', function (e) {
		initDealShareForm();
	});

	$modal.on('hidden.bs.modal', function (e) {
		$modal.find('.modal-body').empty();
	});
}

const initDealLinkModal = () => {
	const $modal = $('.deal-link-modal');

	$('.btn-share-via-link-deal').click(function (e) {
		e.preventDefault();

		const href = $(this).attr('href');

		$.get(href, function (data) {
			$modal.find('.modal-body').empty().html(data);
			$modal.modal({ focus: false });
		});
	});

	var initDealLinkForm = function () {
		const $resetForm = $('.deal-link-form__reset-form');
		const $linkTextbox = $('.deal-link-form__textbox');
		const $copyBtn = $('.deal-link-form__copy-btn');

		const showCopyBtnMessage = (msg: string) => {
			$copyBtn.popover({
				placement: 'bottom',
				content: msg
			} as PopoverOption);

			$copyBtn.popover('show');

			setTimeout(() => {
				$copyBtn.popover('hide');
			}, 3000);
		};

		const fallbackCopyLinkToClipboard = (link: string) => {
			var textArea = document.createElement("textarea");
			textArea.value = link;
			textArea.style.position = "fixed";  //avoid scrolling to bottom
			document.body.appendChild(textArea);
			textArea.focus();
			textArea.select();

			try {
				var successful = document.execCommand('copy');
				if (successful) {
					$linkTextbox.focus();
					$linkTextbox.select();
					showCopyBtnMessage('Copied to clipboard.');
				}
				else {
					showCopyBtnMessage('Something went wrong. Please copy as a text.');
				}
			} catch (err) {
				showCopyBtnMessage('Something went wrong. Please copy as a text.');
			}

			document.body.removeChild(textArea);
		}

		const copyLinkToClipboard = (link: string) => {
			if (!window.navigator.clipboard) {
				fallbackCopyLinkToClipboard(link);
				return;
			}

			window.navigator.clipboard.writeText(link).then(() => {
				showCopyBtnMessage('Copied to clipboard.');
			}, () => {
				showCopyBtnMessage('Something went wrong. Please copy as a text.');
			});
		}

		$copyBtn.on('click', () => {
			$linkTextbox.focus();
			$linkTextbox.select();
			copyLinkToClipboard($linkTextbox.val() as string);
		});

		$resetForm.on('submit', (e) => {
			e.preventDefault();

			$.ajax({
				url: $resetForm.attr('action'),
				type: $resetForm.attr('method'),
				contentType: 'application/x-www-form-urlencoded',
				data: $resetForm.serialize(),
				success: (result) => {
					$linkTextbox.val(result.link);
					$linkTextbox.focus();
					$linkTextbox.select();
				}
			});
		});
	};

	$modal.on('show.bs.modal', function (e) {
		initDealLinkForm();
	});

	$modal.on('hidden.bs.modal', function (e) {
		$modal.find('.modal-body').empty();
	});
}

const initDealDeleteForm = () => {
	$('.delete-deal-form').on('submit', (e) => {
		e.preventDefault();

		if (confirm('Are you sure?')) {
			const $form = $(e.target);

			$.ajax({
				url: $form.attr('action'),
				type: $form.attr('method'),
				contentType: 'application/x-www-form-urlencoded',
				data: $form.serialize(),
				success: (result) => {
					Navigation.visit(result.link);
				}
			})
		}
	});
}

const initDealOpportunityModal = () => {
	$('.btn-connect-to-provider').click(function () {
		Amplitude.logEvent('Deal - Connect to provider', {
			'Project': $('#project-name').val()
		});
	});

	$('#connect-to-provider-modal').find('.save-deal-opportunity').click(function (event) {

		var $form = $('#connect-to-provider-form');

		if ($form.validate().form()) {
			$.ajax({
				data: $form.serialize(),
				type: $form.attr('method'),
				url: $form.attr('action'),
				contentType: 'application/x-www-form-urlencoded',
				success: function () {
					var $status = $('#deal-committed-status');
					$status.removeClass('d-none');
					$('#deal-opportunity').hide();
					$('#connect-to-provider-modal').modal('hide');
				}
			});
		}
	});
}

const trackSignUpButton = () => {
	$('.deal-summary__sign-up .btn').on('click', () => {
		const projectName = $('#project-name').val();
		Amplitude.logEvent('Deal - Sign Up', {
			'Project': projectName
		});
	});
}

export {
	initDealAddModal,
	initDealEditModal,
	initDealShareModal,
	initDealLinkModal,
	initDealDeleteForm,
	initDealOpportunityModal,
	trackSignUpButton
};
